import React from 'react'
import { FaInstagram } from 'react-icons/fa'
import { FiFacebook, FiTwitter, FiYoutube } from 'react-icons/fi'
import { TbMathGreater } from 'react-icons/tb'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="main-footer fl-wrap">
      {/* footer-header*/}
      <div className="footer-header fl-wrap grad ient-dark">
        <div className="container">
          <div className="row">


          </div>
        </div>
      </div>
      {/* footer-header end*/}
      {/*footer-inner*/}
      <div className="footer-inner   fl-wrap">
        <div className="container">
          <div className="row">
            {/* footer-widget*/}
            <div className="col-md-3">
              <div className="footer-widget fl-wrap">
                <div className="footer-logo">
                  <Link to="/">
                    <img style={{ width: "200px", height: "150px" }} src="/image/fly-inn-logo.svg" alt="" />
                  </Link>
                </div>
                <div className="footer-contacts-widget fl-wrap">
                  <p style={{ color: "#3B4249", marginLeft: "-8px" }}>
                    We empower aviation enthusiasts to book and host lodging, transportation and more!
                  </p>


                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="footer-widget fl-wrap">
                <h3>Our Latest News</h3>
                <div className="footer-widget-posts fl-wrap">
                  <ul className="no-list-style">
                    <li className="clearfix">
                      <Link to="#" className="widget-posts-img">
                        <img src="/images/all/4.jpg" className="respimg" alt="" />
                      </Link>
                      <div className="widget-posts-descr">
                        <Link className='h-btn' to="#" title="">
                          Vivamus dapibus rutrum
                        </Link>
                        <span style={{ color: "#4f5962" }} className="widget-posts-date">
                          <i style={{ color: "#4f5962" }} className="fal fa-calendar" /> 21 Mar 09.05{" "}
                        </span>
                      </div>
                    </li>
                    <li className="clearfix">
                      <Link to="#" className="widget-posts-img">
                        <img src="/images/all/2.jpg" className="respimg" alt="" />
                      </Link>
                      <div className="widget-posts-descr">
                        <Link className='h-btn' to="#" title="">
                          {" "}
                          In hac habitasse platea
                        </Link>
                        <span style={{ color: "#4f5962" }} className="widget-posts-date">
                          <i style={{ color: "#4f5962" }} className="fal fa-calendar" /> 7 Mar 18.21{" "}
                        </span>
                      </div>
                    </li>
                    <li className="clearfix">
                      <Link to="#" className="widget-posts-img">
                        <img src="/images/all/7.jpg" className="respimg" alt="" />
                      </Link>
                      <div className="widget-posts-descr">
                        <Link className='h-btn' to="#" title="">
                          Tortor tempor in porta
                        </Link>
                        <span style={{ color: "#4f5962" }} className="widget-posts-date">
                          <i style={{ color: "#4f5962" }} className="fal fa-calendar" /> 7 Mar 16.42{" "}
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="footer-widget fl-wrap">
                <h3>Company</h3>
                <div className="footer-widget-posts fl-wrap">
                  <ul className="footer-list fl-wrap">
                    <li>
                      <Link to="/about">About</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* footer-widget end*/}
            {/* footer-widget  */}
            <div className="col-md-3">
              <div className="footer-widget fl-wrap ">
                <h3>Contact us</h3>
                <ul className="footer-contacts fl-wrap no-list-style">
                  <li>
                    {" "}
                    <span>
                      <i style={{ color: "#4f5962" }} className="fal fa-map-marker" />
                    </span>
                    <Link className='h-btn' to="#" >
                      P.O. Box 270439, Fruitland, UT 84027
                    </Link>
                  </li>
                  <li>
                    <span>
                      <i style={{ color: "#4f5962" }} className="fal fa-phone" />
                    </span>
                    <Link className='h-btn' to="#"> 833-I-Fly-Inn</Link>
                  </li>
                  <li>
                    {" "}
                    <span>
                      <i style={{ color: "#4f5962" }} className="fal fa-phone" />
                    </span>
                    <Link className='h-btn' to="#" >
                      321-I-Fly-Inn
                    </Link>
                  </li>
                  <li>
                    <span>
                      <i style={{ color: "#4f5962" }} className="fal fa-envelope" />
                    </span>



                    <Link className='h-btn' to="mailto:PIC@Fly-Inn.com">
                      <span className='footer_link_changes'> PIC@Fly-Inn.com</span>
                    </Link>

                  </li>
                  <li style={{display:"flex",alignItems:"center"}} onClick={() => window.scrollTo({ top: 0 })}>
                  <TbMathGreater style={{fontSize:"16px"}} />




                    <Link className='h-btn' to="/contact">
                      <span className='footer_link_changes'>Contact us</span>
                    </Link>

                  </li>
                </ul>
               
              </div>
            </div>
            {/* footer-widget end*/}
          </div>
        </div>
        {/* footer bg*/}
        <div className="footer-bg" data-ran={4} />
        <div className="footer-wave">
          <svg viewBox="0 0 100 25">
            <path fill="#fff" d="M0 30 V12 Q30 17 55 12 T100 11 V30z" />
          </svg>
        </div>
        {/* footer bg  end*/}
      </div>
      {/*footer-inner end */}
      {/*sub-footer*/}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        textAlign: "center",
        alignItems: "center",
      }} className="sub-footer  fl-wrap ">
        <div className="container">
          <div style={{
            marginLeft: "72px",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "24px",
            top: "3px"
          }} className="copyright"> FlyInn LLC - All rights reserved © 2020-2024</div>
        </div>
        <div style={{ marginTop: "0px", marginRight: "100px" }} className="footer-social">
          <ul style={{ width: "240px", display: "flex", justifyContent: "space-between", marginLeft: "20px" }} className="no-list-style">
            <li>
              <Link to="https://www.facebook.com/FlyInnLLC/" target="_blank">
                <FiFacebook style={{ fontSize: "20px", color: "#4f5962" }} />
              </Link>
            </li>
            <li>
              <Link to="https://twitter.com/FlyInnLLC" target="_blank">
                <FiTwitter style={{ fontSize: "20px", color: "#4f5962" }} />
              </Link>
            </li>
            <li>
              <Link to="https://www.instagram.com/flyinnllc/" target="_blank">
                <FaInstagram style={{ fontSize: "20px", color: "#4f5962" }} />
              </Link>
            </li>
            <li>
              <Link to="https://www.youtube.com/@FLY-INN" target="_blank">
                <FiYoutube
                  style={{ fontSize: "20px", color: "#4f5962" }} />
              </Link>
            </li>
          </ul>
        </div>
      </div>
      {/*sub-footer end */}
    </footer>
  )
}

export default Footer